import { Box, CircularProgress } from '@mui/material';

/** Centered spinner for lazy route loads (non-homepage). */
export function PageLoader() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh',
                backgroundColor: 'background.default',
            }}
        >
            <CircularProgress />
        </Box>
    );
}
